var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDessert = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#AA4DBF",
  rx: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.6 26.8a.5.5 0 0 1 .4-.8h20a.5.5 0 0 1 .4.8l-1.8 2.4a2 2 0 0 1-1.6.8H13a2 2 0 0 1-1.6-.8l-1.8-2.4Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M9.6 26.8a.5.5 0 0 1 .4-.8h20a.5.5 0 0 1 .4.8l-1.8 2.4a2 2 0 0 1-1.6.8H13a2 2 0 0 1-1.6-.8l-1.8-2.4Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M14 17a1 1 0 0 0-1 1v9h-2v-9a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v9h-2v-9a1 1 0 0 0-1-1H14Z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M22 14a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M20 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM11.2 19.9a1 1 0 0 1 1.4-.2l3.4 2.55 3.4-2.55a1 1 0 0 1 1.2 0l3.4 2.55 3.4-2.55a1 1 0 1 1 1.2 1.6l-4 3a1 1 0 0 1-1.2 0L20 21.75l-3.4 2.55a1 1 0 0 1-1.2 0l-4-3a1 1 0 0 1-.2-1.4Z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M21.354 10.146a.5.5 0 0 1 0 .708l-.415.414a1.5 1.5 0 0 0-.44 1.06V13.5a.5.5 0 1 1-1 0v-1.172a2.5 2.5 0 0 1 .733-1.767l.414-.415a.5.5 0 0 1 .707 0Z",
  clipRule: "evenodd"
})));
SvgDessert.viewBox = '0 0 40 40';
const ForwardRef = /*#__PURE__*/forwardRef(SvgDessert);
export default ForwardRef;